import { useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import axios from "axios";
import { useNavigate } from "react-router-dom";
const CheckOutModal = ({
  isOpen,
  onClose,
  currentCheckIn,
  dataChanged = () => {},
}) => {
  const [load, setLoad] = useState(false);
  const navigate = useNavigate();
  console.log("---ghfj-->", currentCheckIn);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      checkOutDate: new Date().toISOString().split("T")[0],
    },
  });

  const [currentData, setCurrentData] = useState(currentCheckIn);
  const [isChecked, setIsChecked] = useState(false);

  if (!isOpen) return null;

  const onSubmit = async (data) => {
    console.log("Form Data Submitted: ", data);
    setLoad(true);

    let config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/check_in/update_check_in/${currentCheckIn?._id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { ...data, tenantStatus: "Check Out" },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        toast.success("Check-out done successfully");
        dataChanged();
        navigate("/check_outs");
        setLoad(false);
        onClose();
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.message);
        setLoad(false);
        onClose();
      });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="relative h-[30rem] md:h-auto overflow-y-scroll md:overflow-y-hidden bg-white p-8 lg:py-8 lg:px-16 rounded-lg shadow-lg w-full max-w-5xl">
        {/* Modal Header */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-center">Checkout</h2>
          <AiFillCloseCircle
            onClick={onClose}
            className="cursor-pointer text-primaryColor absolute top-4 right-4"
            size={30}
          />
        </div>

        {/* Modal Content */}
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4"
        >
          {/* Name Field */}
          <div>
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-700"
            >
              Name
            </label>
            <input
              type="text"
              id="name"
              value={currentCheckIn?.name}
              placeholder="Sidhartha"
              className="mt-1 p-3 block w-full border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm bg-gray-200"
            />

            {/* <fieldset>
                <legend>Is your cat an indoor or outdoor cat?</legend>
                <label> </label>
              </fieldset> */}
          </div>

          {/* Floor Number */}

          <div>
            <label
              htmlFor="floorNo"
              className="block text-sm font-medium text-gray-700"
            >
              Floor No
            </label>
            <input
              type="text"
              id="roomNo"
              value={`Floor-${currentCheckIn?.roomId?.floorNumber}`}
              placeholder="105"
              className="mt-1 p-3 block w-full border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm bg-gray-200"
            />
          </div>
          {/* Room No Field */}
          <div>
            <label
              htmlFor="roomNo"
              className="block text-sm font-medium text-gray-700"
            >
              Room No
            </label>
            <input
              type="text"
              id="roomNo"
              value={`R-F${currentCheckIn?.floorNo}${String(
                currentCheckIn?.roomId?.roomNumber
              ).padStart(3, "0")}`}
              placeholder="105"
              className="mt-1 p-3 block w-full border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm bg-gray-200"
            />
          </div>

          {/* Bed No Field */}
          <div>
            <label
              htmlFor="bedNo"
              className="block text-sm font-medium text-gray-700"
            >
              Bed No
            </label>
            <input
              type="text"
              id="bedNo"
              placeholder="G-20"
              value={currentCheckIn?.bedId?.bedNumber}
              className="mt-1  p-3 block w-full border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm bg-gray-200"
            />
          </div>

          <div>
            <label
              htmlFor="totalDues"
              className="block text-sm font-medium text-gray-700"
            >
              Total Dues
            </label>
            <input
              type="number"
              id="totalDues"
              value={currentCheckIn?.amountOutstanding}
              className="mt-1  p-3 block w-full border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm bg-gray-200"
            />
          </div>

          {/* Check Out Field */}
          <div>
            <label
              htmlFor="checkOut"
              className="block text-sm font-medium text-gray-700"
            >
              Check Out <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              id="checkOut"
              {...register("checkOutDate", {
                required: "Check Out Date is required !",
              })}
              className="mt-1 p-3 block w-full border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
            />
          </div>

          {/* Checkbox */}
          <div className="sm:col-span-2 flex items-center">
            <input
              type="checkbox"
              // checked={isChecked}
              id="duesCleared"
              checked={!currentCheckIn?.amountOutstanding}
              className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <label
              htmlFor="duesCleared"
              className="ml-2 block text-sm text-gray-700"
            >
              All dues are cleared
            </label>
          </div>

          <div className="sm:col-span-2 flex items-center">
            <input
              type="checkbox"
              // checked={isChecked}
              id="collectedAllHisBelongiings"
              onChange={(e) => {
                setIsChecked(e.target.checked);
              }}
              className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <label
              htmlFor="collectedAllHisBelongiings"
              className="ml-2 block text-sm text-gray-700"
            >
              Tenant has collected all his belongings
            </label>
          </div>

          {/* Buttons */}

          <div className="sm:col-span-2  flex justify-between gap-6 mt-6 tracking-wide">
            <button
              onClick={onClose}
              type="button"
              className="bg-white w-full border hover:bg-secondaryTextColor px-4 py-2 rounded-md"
            >
              Cancel
            </button>
            <button
              disabled={!isChecked || currentCheckIn?.amountOutstanding !== 0}
              type="submit"
              className={`${
                isChecked && currentCheckIn?.amountOutstanding === 0
                  ? "bg-primaryBtnColor text-white hover:bg-primaryBtnHoverColor"
                  : "bg-gray-300 text-gray-800"
              }  w-full bg-gra px-4 py-2 rounded-md`}
            >
              {load ? "Please Wait..." : "Check Out"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CheckOutModal;
